import React, { createContext, useContext, useMemo, useState } from 'react';

interface CameraContextProps {
    isOpen: boolean;
    setOpenCamera: (value: boolean) => void;
}

export const CameraContext = createContext<CameraContextProps>({
    isOpen: false,
    setOpenCamera: () => { },
});

export const CameraProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [isOpen, setOpenCamera] = useState<boolean>(false);
    const value = useMemo(() => ({ isOpen, setOpenCamera }), [isOpen]);
    return (
        <CameraContext.Provider value={value}>
            {children}
        </CameraContext.Provider>
    );
};
